import React from 'react';
import { StyleSheet, css } from 'aphrodite';

import {
  TripAssignments, DateCalculations, VIPLetters, TravelStatus,
} from '../Widgets';


export default () => <div className={css(styles.widgets)}>
  <TravelStatus className={css(styles.largeWidget)} />
  <VIPLetters className={css(styles.widget)} />
  <TripAssignments className={css(styles.widget)} />
  <DateCalculations className={css(styles.widget)} />
</div>;


const styles = StyleSheet.create({
  widgets: {
    display: 'grid',
    paddingRight: 15,
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
  },
  widget: {
    marginTop: 15,
    marginLeft: 15,
  },
  largeWidget: {
    marginTop: 15,
    marginLeft: 15,
    '@media (min-width: 580px)': {
      gridColumnEnd: 'span 2',
    },
    '@media (min-width: 875px)': {
      gridColumnEnd: 'span 3',
    },
  },
});



// WEBPACK FOOTER //
// /src/components/Dashboard/index.js